import { render, staticRenderFns } from "./printers.vue?vue&type=template&id=85376a6e&scoped=true&"
import script from "./printers.vue?vue&type=script&lang=js&"
export * from "./printers.vue?vue&type=script&lang=js&"
import style0 from "./printers.vue?vue&type=style&index=0&id=85376a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85376a6e",
  null
  
)

export default component.exports